import Vue from 'vue'
import VueBodyClass from 'vue-body-class'
import Router from 'vue-router'

import LO001 from '../components/LO001.vue'
import ROOT from '../components/ROOT.vue'
// import HO001 from '../components/home/HO001.vue'
import HO101 from '../components/home/HO101.vue'
// import MR001 from '../components/amm/MR001.vue'
// import MR002 from '../components/amm/MR002.vue'
// import GR001 from '../components/gcs/GR001.vue'
import GR101 from '../components/gcs/GR101.vue'
import GR102 from '../components/gcs/GR102.vue'
// import GR201 from '../components/gcs/GR201.vue'
import CR001 from '../components/ca/CR001.vue'
import CR101 from '../components/ca/CR101.vue'
import CS001 from '../components/cs/CS001.vue'
import CS002 from '../components/cs/CS002.vue'
import CS003 from '../components/cs/CS003.vue'
import CS004 from '../components/cs/CS004.vue'
import CS101 from '../components/cs/CS101.vue'
import CS102 from '../components/cs/CS102.vue'
import CS103 from '../components/cs/CS103.vue'
import CS105 from '../components/cs/CS105.vue'
import CS106 from '../components/cs/CS106.vue'
import GR301 from '../components/gcs/GR301.vue'
import GR302 from '../components/gcs/GR302.vue'
import MA001 from '../components/MA001.vue'
import MA002 from '../components/MA002.vue'
import MA003 from '../components/MA003.vue'
import MA004 from '../components/MA004.vue'
import SE001 from '../components/setting/SE001.vue'
import SE002 from '../components/setting/SE002.vue'
import SE003 from '../components/setting/SE003.vue'
import SE004 from '../components/setting/SE004.vue'
import SE201 from '../components/setting/SE201.vue'
import SE202 from '../components/setting/SE202.vue'
import SE203 from '../components/setting/SE203.vue'
import SE204 from '../components/setting/SE204.vue'
import SE211 from '../components/setting/SE211.vue'
// import MA011 from '../components/MA011.vue'
// import MA101 from '../components/MA101.vue'
import AL001 from '../components/AL001.vue'
import CD001 from '../components/clubdashboard/CD001.vue'
import CD002 from '../components/clubdashboard/CD002.vue'
import HO201 from '../components/home/HO201.vue'
import RD001 from '../components/regiondashboard/RD001.vue'
import RD002 from '../components/regiondashboard/RD002.vue'
import ST001 from '../components/states/ST001.vue'
import ST002 from '../components/states/ST002.vue'
import AccountClubs from '../pages/AccountClubs.vue'

Vue.use(Router)

const routes = [
  { path: '/', component: ROOT },
  {
    path: '/login',
    component: LO001,
    meta: {
      bodyClass: 'loginClub type-index id-login'
    }
  },
  // {
  //   path: '/HO001',
  //   name: 'HO001',
  //   meta: {
  //     bodyClass: 'loginClub type-content id-home-apl asideActive' // asideActive
  //   },
  //   component: HO001
  // },
  {
    path: '/HO101',
    name: 'HO101',
    meta: {
      bodyClass: 'loginClub type-content id-home-club loginClub asideActive' // asideActive
    },
    component: HO101,
    props: true
  },
  // {
  //   path: '/MR001',
  //   name: 'MR001',
  //   meta: {
  //     bodyClass: 'loginClub type-content id-monitoring-summary asideActive' // asideActive
  //   },
  //   component: MR001
  // },
  // {
  //   path: '/MR002',
  //   name: 'MR002',
  //   meta: {
  //     bodyClass: 'loginClub type-content id-monitoring-detail asideActive' // asideActive
  //   },
  //   component: MR002
  // },
  // {
  //   path: '/GR001',
  //   name: 'GR001',
  //   meta: {
  //     bodyClass: 'loginClub type-content id-green-summary asideActive' // asideActive
  //   },
  //   component: GR001
  // },
  {
    path: '/GR101',
    name: 'GR101',
    meta: {
      bodyClass: 'loginClub type-content id-green-temperature-realtime asideActive' // asideActive
    },
    component: GR101
  },
  {
    path: '/GR102',
    name: 'GR102',
    meta: {
      bodyClass: 'loginClub type-content id-green-temperature-term asideActive' // asideActive
    },
    component: GR102
  },
  // {
  //   path: '/GR201',
  //   name: 'GR201',
  //   meta: {
  //     bodyClass: 'loginClub type-content id-green-apl asideActive' // asideActive
  //   },
  //   component: GR201
  // },
  {
    path: '/GR301',
    name: 'GR301',
    meta: {
      bodyClass: 'loginClub type-content id-green-pin-realtime asideActive' // asideActive
    },
    component: GR301
  },
  {
    path: '/GR302',
    name: 'GR302',
    meta: {
      bodyClass: 'loginClub type-content id-green-pin-term asideActive' // asideActive
    },
    component: GR302
  },
  // {
  //   path: '/MA101',
  //   name: 'MA101',
  //   meta: {
  //     bodyClass: 'loginClub type-content id-management-abnormal asideActive' // asideActive
  //   },
  //   component: MA101
  // },
  {
    path: '/CR001',
    name: 'CR001',
    meta: {
      bodyClass: 'loginClub type-content id-course-falling-statistics asideActive' // asideActive
    },
    component: CR001
  },
  {
    path: '/CR101',
    name: 'CR101',
    meta: {
      bodyClass: 'loginClub type-content id-course-pin-statistics asideActive' // asideActive
    },
    component: CR101
  },
  {
    path: '/CS001',
    name: 'CS001',
    meta: {
      bodyClass: 'loginClub type-content id-customer-notice-list' +
        ' asideActive' // asideActive
    },
    component: CS001
  },
  {
    path: '/CS002',
    name: 'CS002',
    meta: {
      bodyClass: 'loginClub type-content id-customer-notice-view' +
        ' asideActive' // asideActive
    },
    component: CS002
  },
  {
    path: '/CS003',
    name: 'CS003',
    meta: {
      bodyClass: 'loginClub type-content id-customer-notice-registration' +
        ' asideActive' // asideActive
    },
    component: CS003
  },
  {
    path: '/CS004',
    name: 'CS004',
    meta: {
      bodyClass: 'loginClub type-content id-customer-notice-edit' +
        ' asideActive' // asideActive
    },
    component: CS004
  },
  {
    path: '/CS101',
    name: 'CS101',
    meta: {
      bodyClass: 'loginClub type-content id-customer-inquiry-list' +
        ' asideActive' // asideActive
    },
    component: CS101
  },
  {
    path: '/CS102',
    name: 'CS102',
    meta: {
      bodyClass: 'loginClub type-content id-customer-inquiry-view-ing' +
        ' asideActive' // asideActive
    },
    component: CS102
  },
  {
    path: '/CS103',
    name: 'CS103',
    meta: {
      bodyClass: 'loginClub type-content id-customer-inquiry-registration-question' +
        ' asideActive' // asideActive
    },
    component: CS103
  },
  {
    path: '/CS105',
    name: 'CS105',
    meta: {
      bodyClass: 'loginClub type-content id-customer-inquiry-registration-answer' +
        ' asideActive' // asideActive
    },
    component: CS105
  },
  {
    path: '/CS106',
    name: 'CS106',
    meta: {
      bodyClass: 'loginClub type-content id-customer-inquiry-edit-answer' +
        ' asideActive' // asideActive
    },
    component: CS106
  },
  {
    path: '/SE001',
    name: 'SE001',
    meta: {
      bodyClass: 'loginClub type-content id-settings-club-list' +
        ' asideActive' // asideActive
    },
    component: SE001
  },
  {
    path: '/SE002',
    name: 'SE002',
    meta: {
      bodyClass: 'loginClub type-content id-settings-club-view' +
        ' asideActive' // asideActive
    },
    component: SE002
  },
  {
    path: '/SE003',
    name: 'SE003',
    meta: {
      bodyClass: 'loginClub type-content id-settings-club-registration' +
        ' asideActive' // asideActive
    },
    component: SE003
  },
  {
    path: '/SE004',
    name: 'SE004',
    meta: {
      bodyClass: 'loginClub type-content id-settings-club-edit' +
        ' asideActive' // asideActive
    },
    component: SE004
  },
  {
    path: '/SE201',
    name: 'SE201',
    meta: {
      bodyClass: 'loginClub type-content id-settings-notification-list' +
        ' asideActive' // asideActive
    },
    component: SE201
  },
  {
    path: '/SE202',
    name: 'SE202',
    meta: {
      bodyClass: 'loginClub type-content id-settings-notification-view' +
        ' asideActive' // asideActive
    },
    component: SE202
  },
  {
    path: '/SE203',
    name: 'SE203',
    meta: {
      bodyClass: 'loginClub type-content id-settings-notification-registration' +
        ' asideActive' // asideActive
    },
    component: SE203
  },
  {
    path: '/SE204',
    name: 'SE204',
    meta: {
      bodyClass: 'loginClub type-content id-settings-notification-edit' +
        ' asideActive' // asideActive
    },
    component: SE204
  },
  {
    path: '/SE211',
    name: 'SE211',
    meta: {
      bodyClass: 'loginClub type-content id-settings-notification-reception' +
        ' asideActive' // asideActive
    },
    component: SE211
  },
  {
    path: '/MA003',
    name: 'MA003',
    meta: {
      bodyClass: 'loginClub type-content id-management-user-registration' +
        ' asideActive' // asideActive
    },
    component: MA003
  },
  {
    path: '/MA004',
    name: 'MA004',
    meta: {
      bodyClass: 'loginClub type-content id-management-user-edit' +
        ' asideActive' // asideActive
    },
    component: MA004
  },
  // {
  //   path: '/MA011',
  //   name: 'MA011',
  //   meta: {
  //     bodyClass: 'loginClub type-index id-resetPassword'
  //   },
  //   component: MA011
  // },
  {
    path: '/MA001',
    name: 'MA001',
    meta: {
      bodyClass: 'loginClub type-content id-management-user-list' +
        ' asideActive' // asideActive
    },
    component: MA001
  },
  {
    path: '/MA002',
    name: 'MA002',
    meta: {
      bodyClass: 'loginClub type-content id-management-user-view' +
        ' asideActive' // asideActive
    },
    component: MA002
  },
  {
    path: '/AL001',
    name: 'AL001',
    meta: {
      bodyClass: 'loginClub type-content id-notification-box' +
        ' asideActive' // asideActive
    },
    component: AL001
  },
  {
    path: '/HO201',
    name: 'HO201',
    meta: {
      bodyClass: 'loginClub type-content id-aplRealtimeStatus' +
        ' asideActive' // asideActive
    },
    component: HO201
  },
  {
    path: '/RD001',
    name: 'RD001',
    meta: {
      bodyClass: 'loginClub type-content id-regionStatus-abnormal' +
        ' asideActive' // asideActive
    },
    component: RD001
  },
  {
    path: '/RD002',
    name: 'RD002',
    meta: {
      bodyClass: 'loginClub type-content id-regionStatus-batteryCharge' +
        ' asideActive' // asideActive
    },
    component: RD002
  },
  {
    path: '/CD001',
    name: 'CD001',
    meta: {
      bodyClass: 'loginClub type-content id-golfClubStatus' +
        ' asideActive' // asideActive
    },
    component: CD001
  },
  {
    path: '/CD002',
    name: 'CD002',
    meta: {
      bodyClass: 'loginClub type-content id-golfClubBatteryStatus' +
        ' asideActive' // asideActive
    },
    component: CD002
  },
  {
    path: '/ST001',
    name: 'ST001',
    meta: {
      bodyClass: 'loginClub type-content id-statistics' +
        ' asideActive' // asideActive
    },
    component: ST001
  },
  {
    path: '/ST002',
    name: 'ST002',
    meta: {
      bodyClass: 'loginClub type-content id-statistics' +
        ' asideActive' // asideActive
    },
    component: ST002
  },
  {
    path: '/account-clubs',
    name: 'AccountClubs',
    meta: {
      bodyClass: 'loginClub type-content id-statistics' +
        ' asideActive' // asideActive
    },
    component: AccountClubs
  },
  // otherwise redirect to home ManagementUserModify
  { path: '*', redirect: '/' }
]

const vueBodyClass = new VueBodyClass(routes)

export const router = new Router({
  mode: 'history',
  routes: routes,
  scrollBehavior: function (to, from) {
    return {x: 0, y: 0}
  }
})

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  vueBodyClass.guard(to, next)
  const publicPages = ['/login']
  const authRequired = !(publicPages.indexOf(to.path) !== -1)
  const loggedIn = localStorage.getItem('user')

  if (authRequired && !loggedIn) {
    return next({path: '/login', replace: true})
  }

  next()
})



// WEBPACK FOOTER //
// ./src/backend/router.js